// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CvssModifiedScopeSchema = z.enum(['X','U','C'] as const);

export type CvssModifiedScopeType = `${z.infer<typeof CvssModifiedScopeSchema>}`

export default CvssModifiedScopeSchema;
